import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DropdownDTO } from "../../../types/common/DropdownDTO";

interface IExportRegimeState {
  exportRegimeDropdown: DropdownDTO[];
}

const initialState: IExportRegimeState = {
  exportRegimeDropdown: []
};

export const exportRegimeSlice = createSlice({
  name: 'exportRegime',
  initialState,
  reducers: {
    loadingExportRegimeDropdown: (state, action: PayloadAction<DropdownDTO[]>) => {
      state.exportRegimeDropdown = action.payload;
    },
  }
});

export const { loadingExportRegimeDropdown } = exportRegimeSlice.actions;
export default exportRegimeSlice.reducer;
